import {
  TableData,
  TableExtraItemType,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { LabeledProductInterface } from "../../../../redux/interfaces/receipt.interface";
import { dateToString, getDateAndTime } from "../../../../utils/dateAndTime";

export const labeledProductsTableHeader: TableHeaderCategoryConfig[] = [
  { value: "Nume produs", minW: 300 },
  { value: "Cod Extern", minW: 125 },
  { value: "Cod bare", minW: 125 },
  { value: "Lot", minW: 100 },
  { value: "Data expirare", minW: 125 },
  { value: "Cant la etichetare", minW: 150 },
  { value: "Data trimitere", minW: 150 },
  { value: "Utilizator", minW: 125 },
];

export const getLabeledProductsTableData = (
  products: LabeledProductInterface[],
): TableData[] => {
  const extraHeaderCategories: TableExtraItemType[] = [
    "Nume produs",
    "Cod intern",
    "",
    "Lot",
    "",
    "Cantitate primită",
    "Data operație",
    "Utilizator",
    "",
  ].map((item) => {
    if (!item) {
      return { title: "" };
    }

    return {
      badges: [
        {
          badgeText: item,
          badgeColor: "secondary",
        },
      ],
    };
  });

  const getExtraDataItems = (
    receivedQuantities: LabeledProductInterface["cantitatePrimita"],
  ): TableExtraItemType[][] =>
    receivedQuantities.map((receivedQuantity) => [
      {
        title: receivedQuantity.numeProdusErp ?? "-",
      },
      { title: receivedQuantity.codProdusErp ?? "-" },
      { title: "" },
      { title: receivedQuantity.lot ?? "-" },
      { title: "" },
      { title: receivedQuantity.cantitate_primita ?? 0 },
      {
        badges: [
          {
            badgeText: getDateAndTime(receivedQuantity.ts_operatie, "-"),
            badgeColor: "light-info",
          },
        ],
      },
      { title: receivedQuantity.userName ?? "-" },
      { title: "" },
    ]);

  return products.map((product, index) => ({
    id:
      product.idMarfaTrimisaEtichetat ??
      product.id ??
      product.idReceptie ??
      index,
    crudData: product,
    extraData: product.cantitatePrimita?.length
      ? [extraHeaderCategories, ...getExtraDataItems(product.cantitatePrimita)]
      : undefined,
    extraDataPreset: "grouped",
    data: [
      {
        title: product.numeProdusErp ?? "-",
      },
      { title: product.codProdusErp ?? "-" },
      { title: product.sn ?? "-" },
      { title: product.lot ?? "-" },
      {
        badges: [
          {
            badgeText: dateToString(product.dataExpirare, "-"),
            badgeColor: "light-danger",
          },
        ],
      },
      { title: product.cantitate ?? 0 },
      {
        badges: [
          {
            badgeText: getDateAndTime(product.dataTrimitere, "-"),
            badgeColor: "light-info",
          },
        ],
      },
      { title: product.userName ?? "-" },
    ],
  }));
};
